import React, { useState, useEffect } from "react";
import "../../../../css/genesis.css";
import "../../../../css/toggleOnOff.css";

import { images } from "../../../../Shared/images";
import geneSisImage from "../../../../images/genesis-node.png";
import swal from "sweetalert";
import constant from "../../../../Shared/constants/constants";
import erc20Abi from "../../../../Shared/erc20Abi.json";
import genesisNodeAbi from "../../../../Shared/genesisNodeAbi.json";

import BigNumber from "bignumber.js";
import Web3 from "web3";
import Cookies from "universal-cookie";
const cookies = new Cookies();

function GenesisNodePage() {
	const [count, setCount] = useState(1);
	const [toggle, setToggle] = useState(false);
	const [web3, setWeb3] = useState(null);
	const [isWalletConnected, setWalletConnected] = useState(false);
	const [connectedWallet, setConnectedWallet] = useState(false);
	const [isAlreadyApproved, setIsAlreadyApproved] = useState(false);
	const [isApprovedTxAvailable, setIsApprovedTxAvailable] = useState(false);
	const [approvedTx, setApprovedTx] = useState(null);
	const [claimableRewards, setClaimableRewards] = useState(0);
	const [filledSlots, setFilledSlots] = useState(0);
	const [availableSlots, setAvailableSlots] = useState(0);
	const [getUserInfo, setGetUserInfo] = useState(0);
	const [isWalletBlacklisted, setIsWalletBlacklisted] = useState(false);
	const [isWalletWhitelisted, setIsWalletWhitelisted] = useState(false);
	const [minimumStake, setMinimumStake] = useState(0);
	const [maximumStake, setMaximumStake] = useState(0);
	const [totalClaimedRewards, setTotalClaimedRewards] = useState(0);
	const [totalStake, setTotalStake] = useState(0);
	const [maxSlots, setMaxSlots] = useState(10);

	const decreaseCount = () => {
		let min = 1;
		setCount((prevCount) => (prevCount <= min ? min : prevCount - 1));
		isStakingContractApproved(count);
	};

	const increaseCount = () => {
		let max = 10;
		// console.log("toggle", toggle);
		if (toggle == false) {
			max = maxSlots - filledSlots;
		} else {
			max = filledSlots;
		}
		setCount((prevCount) => (prevCount >= max ? max : prevCount + 1));
		isStakingContractApproved(count);
	};

	const getWeb3 = () => {
		if (window.ethereum) {
			try {
				window.web3 = new Web3(window.ethereum);
				setWeb3(window.web3);
			} catch (error) {
				console.log(
					`[nft][src][components][components][Dashboard][Home][GenesisModePage] Web3 Connection Error`,
					error
				);
			}
		} else {
			setWeb3(null);
		}
	};

	const connectToWallet = async () => {
		console.log(
			`[nft][src][components][components][Dashboard][Home][GenesisModePage] connectToWallet`
		);
		if (typeof window.ethereum !== "undefined") {
			let accounts = await window.ethereum.request({
				method: "eth_requestAccounts",
			});
			window.web3 = new Web3(window.ethereum);
			setWeb3(window.web3);
			let chainId = await window.web3.eth.getChainId();
			if (chainId !== parseInt(constant.CHAIN_ID)) {
				swal({
					title: "Invalid Network!",
					text: `Switch your network to ${constant.NETWORK_NAME}`,
					icon: "error",
					confirmButtonText: "Ok",
				});
				return;
			}
			cookies.set("wallet", accounts[0], { path: "/" });
			cookies.set("wallet_status", 1, { path: "/" });
			setWalletConnected(true);
			setConnectedWallet(accounts[0]);
			setWeb3(window.web3);
			window.location.reload();
		} else {
			cookies.set("wallet", null, { path: "/" });
			cookies.set("wallet_status", 0, { path: "/" });
			setWalletConnected(false);
			setConnectedWallet(null);
			setWeb3(null);
			console.log("Unsupported Browser/Plugin not installed");
		}
	};

	const walletStatus = async () => {
		try {
			let _walletAddress = cookies.get("wallet");
			let _isWalletConnected = cookies.get("wallet_status");
			console.log(
				`[nft][src][components][components][Dashboard][Home][GenesisModePage] _walletAddress`,
				_walletAddress
			);
			console.log(
				`[nft][src][components][components][Dashboard][Home][GenesisModePage] _isWalletConnected`,
				_isWalletConnected
			);
			if (parseInt(_isWalletConnected) == 1 || _isWalletConnected == "1") {
				// console.log("I am in");
				setWalletConnected(true);
				setConnectedWallet(_walletAddress);
				let _web3 = await new Web3(window.ethereum);
				setWeb3(_web3);

				// get staking contract info
				let Genesis = await new _web3.eth.Contract(
					genesisNodeAbi,
					constant.AVAX_GENESIS_CONTRACT
				);
				// console.log(Genesis);
				let _calculateRewards = await Genesis.methods
					.calculateRewards(_walletAddress)
					.call();
				// console.log(_calculateRewards, "_calculateRewards")
				let __calculateRewards = await _web3.utils.fromWei(
					_calculateRewards,
					"ether"
				);
				setClaimableRewards(__calculateRewards);

				let _filledSlots = await Genesis.methods
					.filledSlots(_walletAddress)
					.call();
				setFilledSlots(_filledSlots);
				setAvailableSlots(maxSlots - _filledSlots);

				let _getUserInfo = await Genesis.methods
					.getUserInfo(_walletAddress)
					.call();
				// console.log(_getUserInfo, "_getUserInfo")
				setGetUserInfo(_getUserInfo);

				let _isWalletBlacklisted = await Genesis.methods
					.isWalletBlacklisted(_walletAddress)
					.call();
				setIsWalletBlacklisted(_isWalletBlacklisted);

				let _isWalletWhitelisted = await Genesis.methods
					.isWalletWhitelisted(_walletAddress)
					.call();
				setIsWalletWhitelisted(_isWalletWhitelisted);

				let _minimumStake = await Genesis.methods.minimumStake().call();
				let __minimumStake = await _web3.utils.fromWei(_minimumStake, "ether");
				setMinimumStake(__minimumStake);
				// check if the staking contract approved by user or not
				isStakingContractApproved(_minimumStake);

				let _maximumStake = await Genesis.methods.maximumStake().call();
				let __maximumStake = await _web3.utils.fromWei(_maximumStake, "ether");
				setMaximumStake(__maximumStake);

				let _totalClaimedRewards = await Genesis.methods
					.totalClaimedRewards(_walletAddress)
					.call();
				// console.log(_totalClaimedRewards, "_totalClaimedRewards")
				let __totalClaimedRewards = await _web3.utils.fromWei(
					_totalClaimedRewards,
					"ether"
				);
				setTotalClaimedRewards(__totalClaimedRewards);

				let _totalStake = await Genesis.methods
					.totalStake(_walletAddress)
					.call();
				let __totalStake = await _web3.utils.fromWei(_totalStake, "ether");
				// console.log(_totalStake, "_totalStake")
				setTotalStake(__totalStake);
			} else {
				setWalletConnected(false);
				setConnectedWallet(false);
			}
		} catch (error) {}
	};

	const waitTransactionReceipt = async (
		transactionHash,
		actionType,
		timeOut,
		callback
	) => {
		console.log(
			"[nft][src][components][components][modal][waitTransactionReceipt] transactionHash",
			transactionHash
		);
		var web3 = new Web3(window.ethereum);

		let timeOutCounter = 0;
		let err = {
			message: "",
		};

		let isWaitRunning = false;

		let getReceiptTimerId = setInterval(function () {
			if (isWaitRunning == false) {
				isWaitRunning = true;
				web3.eth
					.getTransaction(transactionHash)
					.then(function (tx) {
						if (tx == null) {
							clearInterval(getReceiptTimerId);
							console.log(
								`[nft][src][components][components][modal][waitTransactionReceipt] transactionHash ${transactionHash} is not found`
							);
							err.message = "Transaction hash is not found.";
							isWaitRunning = false;
							if (callback) {
								callback(err, null);
							}
							return;
						}

						if (tx.blockNumber == null) {
							if (timeOut > 0) {
								timeOutCounter++;
								if (timeOutCounter >= timeOut) {
									clearInterval(getReceiptTimerId);
									isWaitRunning = false;
									err.message = "Timeout while waiting transaction to confirm.";
									if (callback) {
										callback(err, null);
									}
									return;
								} else {
									console.log(
										`[nft][src][components][components][modal][waitTransactionReceipt] transactionHash 1 ${transactionHash} is pending`
									);
									isWaitRunning = false;
									return;
								}
							} else {
								console.log(
									`[nft][src][components][components][modal][waitTransactionReceipt] transactionHash 2 ${transactionHash} is pending`
								);
								isWaitRunning = false;
								return;
							}
						}

						// Transaction confirm
						web3.eth
							.getTransactionReceipt(transactionHash)
							.then(async function (web3TxReceipt) {
								clearInterval(getReceiptTimerId);
								isWaitRunning = false;
								if (web3TxReceipt == null) {
									console.log(
										`[nft][src][components][components][modal][waitTransactionReceipt] transactionHash 2 ${transactionHash} is not found`
									);
									swal({
										icon: "error",
										title: "Failed",
										text: "Transaction Failed. Please try again!",
										showConfirmButton: true,
										showCancelButton: false,
										closeOnClickOutside: true,
									});
									setIsAlreadyApproved(false);
								}
								console.log(
									`[nft][src][components][components][modal][waitTransactionReceipt] Transaction receipt ${transactionHash}: ${web3TxReceipt}`
								);
								if (web3TxReceipt.status != false) {
									if (actionType == "approve") {
										swal({
											icon: "success",
											title: "Approved",
											text: "Transaction Successful",
											showConfirmButton: true,
											showCancelButton: false,
											closeOnClickOutside: true,
										});
										setIsAlreadyApproved(true);
									} else if (actionType == "stake") {
										swal({
											icon: "success",
											title: "Staked",
											text: "Transaction Successful",
											showConfirmButton: true,
											showCancelButton: false,
											closeOnClickOutside: true,
										}).then(() => {
											window.location.reload();
										});
									} else if (actionType == "unstake") {
										swal({
											icon: "success",
											title: "Unstaked",
											text: "Transaction Successful",
											showConfirmButton: true,
											showCancelButton: false,
											closeOnClickOutside: true,
										}).then(() => {
											window.location.reload();
										});
									} else if (actionType == "claim") {
										swal({
											icon: "success",
											title: "Claimed",
											text: "Transaction Successful",
											showConfirmButton: true,
											showCancelButton: false,
											closeOnClickOutside: true,
										}).then(() => {
											window.location.reload();
										});
									}
								}
							})
							.catch(function (error) {
								clearInterval(getReceiptTimerId);
								isWaitRunning = false;
								console.log(
									`[nft][src][components][components][modal][waitTransactionReceipt] Error on transaction receipt 1 ${transactionHash}: ${error}`
								);
								swal({
									icon: "error",
									title: "Cancelled",
									text: error.message,
									showConfirmButton: true,
									showCancelButton: false,
									closeOnClickOutside: true,
								});
								setIsAlreadyApproved(false);
							});
					})
					.catch(function (error) {
						clearInterval(getReceiptTimerId);
						console.log(
							`[nft][src][components][components][modal][waitTransactionReceipt] Error on transaction receipt 2 ${transactionHash}: ${error}`
						);
						swal({
							icon: "error",
							title: "Cancelled",
							text: error.message,
							showConfirmButton: true,
							showCancelButton: false,
							closeOnClickOutside: true,
						});
						setIsAlreadyApproved(false);
					});
			}
		}, 1000);
	};

	const isStakingContractApproved = async (amountToApprove) => {
		try {
			// console.log(`[nft][src][components][components][Dashboard][Home][isStakingContractApproved] selectedToken`, constant.AVAX_NCASH);
			let _web3 = await new Web3(window.ethereum);
			let erc20 = await new _web3.eth.Contract(erc20Abi, constant.AVAX_NCASH);

			let _isWalletConnected = cookies.get("wallet_status");
			let _walletAddress = cookies.get("wallet");
			console.log(_web3, _isWalletConnected, _walletAddress);

			// balance to Pay
			let balanceToPay = new BigNumber(amountToApprove);

			if (
				_isWalletConnected == true ||
				_isWalletConnected == "1" ||
				parseInt(_isWalletConnected) == 1
			) {
				if (connectToWallet != null) {
					let isApproved = await erc20.methods
						.allowance(_walletAddress, constant.AVAX_GENESIS_CONTRACT)
						.call();

					let decimal = await erc20.methods.decimals().call();

					let baseBN = new BigNumber(10);
					let decimalBN = new BigNumber(decimal);

					let exponentiate = baseBN.exponentiatedBy(decimalBN);

					let isApprovedBN = new BigNumber(isApproved);
					let balanceToPayBN = new BigNumber(balanceToPay).multipliedBy(
						exponentiate
					);

					let res = isApprovedBN.comparedTo(balanceToPayBN);
					console.log(
						`[nft][src][components][components][Dashboard][Home][isStakingContractApproved] res`,
						res
					);

					if (res === 0 || res === 1) {
						setIsAlreadyApproved(true);
					} else if (res === -1) {
						setIsAlreadyApproved(false);
					}
					console.log(
						`[nft][src][components][components][Dashboard][Home][isStakingContractApproved] Is Approved`,
						isAlreadyApproved
					);
				}
			} else {
				setIsAlreadyApproved(false);
			}
		} catch (error) {
			setIsAlreadyApproved(false);
			console.log(error);
		}
	};

	const approveToken = async () => {
		if (isWalletConnected == true) {
			let web3 = new Web3(window.ethereum);
			let accounts = await web3.eth.getAccounts();

			console.log(
				"[nft][src][components][components][Dashboard][Home][approveToken] Initiated"
			);

			let contractToApprove = constant.AVAX_GENESIS_CONTRACT;
			let valueToApprove =
				"0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff";

			let ERC20 = await new web3.eth.Contract(erc20Abi, constant.AVAX_NCASH);

			try {
				await ERC20.methods
					.approve(contractToApprove, valueToApprove)
					.send({ from: accounts[0] })
					.on("transactionHash", function (hash) {
						setIsApprovedTxAvailable(true);
						console.log(
							"[nft][src][components][components][Dashboard][Home][approveToken] Approve Tx Hash",
							hash
						);
						let txHash = `${constant.EXPLORER_URL}/tx/${hash}`;
						setApprovedTx(txHash);
						swal({
							icon: "info",
							title: "In progress",
							text: `Transaction Initiated, Please wait!`,
							closeOnClickOutside: false,
							buttons: ["View Transaction"],
							cancel: false,
							confirm: false,
						}).then(function () {
							window.location = `${constant.EXPLORER_URL}/tx/${hash}`;
						});

						waitTransactionReceipt(hash, "approve", 0, function (err, receipt) {
							if (err != null) {
								return;
							}
						});
					})
					.on("error", function (error, receipt) {
						console.log(
							"[nft][src][components][components][Dashboard][Home][approveToken] Approve Tx Error",
							error
						);
						swal({
							icon: "error",
							title: "Failed",
							text: "Transaction cancelled. Please try again!",
							showConfirmButton: true,
							showCancelButton: false,
							closeOnClickOutside: true,
						});
						setIsAlreadyApproved(false);
						return;
					});
			} catch (error) {
				console.log(
					"[nft][src][components][components][Dashboard][Home][approveToken] Catch Error",
					error
				);
				swal({
					icon: "error",
					title: "Failed",
					text: "Something went wrong. Please try again!",
					showConfirmButton: true,
					showCancelButton: false,
					closeOnClickOutside: true,
				});
				setIsAlreadyApproved(false);
			}
		}
	};

	const stakeToken = async () => {
		if (isWalletConnected == true) {
			let web3 = new Web3(window.ethereum);
			let accounts = await web3.eth.getAccounts();

			console.log(
				"[nft][src][components][components][Dashboard][Home][stakeToken] Initiated",
				count
			);

			if (count > maxSlots - filledSlots) {
				swal({
					icon: "error",
					title: "Invalid",
					text: `You have 0 units available for stake/unstake. Please check and try again.`,
					closeOnClickOutside: true,
					showCancelButton: true,
					buttons: ["View Transaction"],
					cancel: true,
					confirm: false,
				});
				return;
			}

			let Genesis = await new web3.eth.Contract(
				genesisNodeAbi,
				constant.AVAX_GENESIS_CONTRACT
			);
			let NCash = await new web3.eth.Contract(erc20Abi, constant.AVAX_NCASH);

			let userBalance = await NCash.methods.balanceOf(accounts[0]).call();
			// console.log(userBalance);
			let userBalanceBN = BigNumber(userBalance);

			let _countBN = BigNumber(count);
			let __countBN = _countBN.multipliedBy(BigNumber(100000));
			let amountToStake = await web3.utils.toWei(__countBN.toString(), "ether");

			let res = userBalanceBN.comparedTo(BigNumber(amountToStake));
			// console.log(res);

			if (res == -1) {
				swal({
					icon: "info",
					title: "Insufficient Balance",
					text: `Insufficient Balance`,
					closeOnClickOutside: true,
					cancel: false,
					confirm: true,
				});
				return;
			}

			console.log(
				"[nft][src][components][components][Dashboard][Home][stakeToken] amountToStake",
				amountToStake
			);

			try {
				await Genesis.methods
					.stake(amountToStake)
					.send({ from: accounts[0] })
					.on("transactionHash", function (hash) {
						setIsApprovedTxAvailable(true);
						console.log(
							"[nft][src][components][components][Dashboard][Home][stakeToken] Approve Tx Hash",
							hash
						);
						let txHash = `${constant.EXPLORER_URL}/tx/${hash}`;
						setApprovedTx(txHash);
						swal({
							icon: "info",
							title: "In progress",
							text: `Transaction Initiated, Please wait!`,
							closeOnClickOutside: false,
							buttons: ["View Transaction"],
							cancel: false,
							confirm: false,
						}).then(function () {
							window.location = `${constant.EXPLORER_URL}/tx/${hash}`;
						});

						waitTransactionReceipt(hash, "stake", 0, function (err, receipt) {
							if (err != null) {
								return;
							}
						});
					})
					.on("error", function (error, receipt) {
						console.log(
							"[nft][src][components][components][Dashboard][Home][stakeToken] Approve Tx Error",
							error
						);
						swal({
							icon: "error",
							title: "Failed",
							text: "Transaction cancelled. Please try again!",
							showConfirmButton: true,
							showCancelButton: false,
							closeOnClickOutside: true,
						});
						setIsAlreadyApproved(false);
						return;
					});
			} catch (error) {
				console.log(
					"[nft][src][components][components][Dashboard][Home][stakeToken] Catch Error",
					error
				);
				swal({
					icon: "error",
					title: "Failed",
					text: "Something went wrong. Please try again!",
					showConfirmButton: true,
					showCancelButton: false,
					closeOnClickOutside: true,
				});
				setIsAlreadyApproved(false);
			}
		}
	};

	const unStakeToken = async () => {
		if (isWalletConnected == true) {
			let web3 = new Web3(window.ethereum);
			let accounts = await web3.eth.getAccounts();

			console.log(
				"[nft][src][components][components][Dashboard][Home][unStakeToken] Initiated",
				count
			);

			if (count > filledSlots) {
				swal({
					icon: "error",
					title: "Invalid",
					text: `You have 0 units available for stake/unstake. Please check and try again.`,
					closeOnClickOutside: true,
					showCancelButton: true,
					buttons: ["View Transaction"],
					cancel: true,
					confirm: false,
				});
				return;
			}

			let Genesis = await new web3.eth.Contract(
				genesisNodeAbi,
				constant.AVAX_GENESIS_CONTRACT
			);
			let _countBN = BigNumber(count);
			let __countBN = _countBN.multipliedBy(BigNumber(100000));
			let amountToUnStake = await web3.utils.toWei(
				__countBN.toString(),
				"ether"
			);

			console.log(
				"[nft][src][components][components][Dashboard][Home][unStakeToken] amountToUnStake",
				amountToUnStake
			);
			// return;

			try {
				await Genesis.methods
					.unStake(amountToUnStake)
					.send({ from: accounts[0] })
					.on("transactionHash", function (hash) {
						setIsApprovedTxAvailable(true);
						console.log(
							"[nft][src][components][components][Dashboard][Home][unStakeToken] unStakeToken Tx Hash",
							hash
						);
						let txHash = `${constant.EXPLORER_URL}/tx/${hash}`;
						setApprovedTx(txHash);
						swal({
							icon: "info",
							title: "In progress",
							text: `Transaction Initiated, Please wait!`,
							closeOnClickOutside: false,
							buttons: ["View Transaction"],
							cancel: false,
							confirm: false,
						}).then(function () {
							window.location = `${constant.EXPLORER_URL}/tx/${hash}`;
						});

						waitTransactionReceipt(hash, "unstake", 0, function (err, receipt) {
							if (err != null) {
								return;
							}
						});
					})
					.on("error", function (error, receipt) {
						console.log(
							"[nft][src][components][components][Dashboard][Home][unStakeToken] unStakeToken Tx Error",
							error
						);
						swal({
							icon: "error",
							title: "Failed",
							text: "Transaction cancelled. Please try again!",
							showConfirmButton: true,
							showCancelButton: false,
							closeOnClickOutside: true,
						});
						setIsAlreadyApproved(false);
						return;
					});
			} catch (error) {
				console.log(
					"[nft][src][components][components][Dashboard][Home][unStakeToken] Catch Error",
					error
				);
				swal({
					icon: "error",
					title: "Failed",
					text: "Something went wrong. Please try again!",
					showConfirmButton: true,
					showCancelButton: false,
					closeOnClickOutside: true,
				});
				setIsAlreadyApproved(false);
			}
		}
	};

	const claimRewards = async () => {
		if (isWalletConnected == true) {
			let web3 = new Web3(window.ethereum);
			let accounts = await web3.eth.getAccounts();

			let Genesis = await new web3.eth.Contract(
				genesisNodeAbi,
				constant.AVAX_GENESIS_CONTRACT
			);

			try {
				await Genesis.methods
					.claimRewards()
					.send({ from: accounts[0] })
					.on("transactionHash", function (hash) {
						setIsApprovedTxAvailable(true);
						console.log(
							"[nft][src][components][components][Dashboard][Home][claimRewards] claimRewards Tx Hash",
							hash
						);
						let txHash = `${constant.EXPLORER_URL}/tx/${hash}`;
						setApprovedTx(txHash);
						swal({
							icon: "info",
							title: "In progress",
							text: `Transaction Initiated, Please wait!`,
							closeOnClickOutside: false,
							buttons: ["View Transaction"],
							cancel: false,
							confirm: false,
						}).then(function () {
							window.location = `${constant.EXPLORER_URL}/tx/${hash}`;
						});

						waitTransactionReceipt(hash, "claim", 0, function (err, receipt) {
							if (err != null) {
								return;
							}
						});
					})
					.on("error", function (error, receipt) {
						console.log(
							"[nft][src][components][components][Dashboard][Home][claimRewards] claimRewards Tx Error",
							error
						);
						swal({
							icon: "error",
							title: "Failed",
							text: "Transaction cancelled. Please try again!",
							showConfirmButton: true,
							showCancelButton: false,
							closeOnClickOutside: true,
						});
						return;
					});
			} catch (error) {
				console.log(
					"[nft][src][components][components][Dashboard][Home][claimRewards] Catch Error",
					error
				);
				swal({
					icon: "error",
					title: "Failed",
					text: "Something went wrong. Please try again!",
					showConfirmButton: true,
					showCancelButton: false,
					closeOnClickOutside: true,
				});
			}
		}
	};

	useEffect(() => {
		(async () => {
			await walletStatus();
		})();
	}, []);

	return (
		<div className="genesis-node-page">
			<div className="genesis-container">
				<h2>GENESIS NODE</h2>
				<div className="flex-genesis">
					<div className="image-genesis">
						<img src={geneSisImage} alt="Genesis image" />
					</div>
					<div className="text-genesis">
						<p>
							Welcome to the Genesis Node Portal! This is Nitro’s legacy program
							that is created to reward long-term NCash holders. The privileges
							available to a Genesis Node are numerous. Certain wallets have
							qualified by meeting the laid out requirements of a previous
							staking program.
						</p>
						<ul
							style={{
								listStyle: "disc",
							}}
						>
							<li>Only qualified Genesis Node can stake in this portal</li>
							<li>You have to stake a minimum of 100,000 NCash tokens</li>
							<li>You can stake up to a maximum of 1,000,000 NCash per user</li>
							<li>Each 100,000 NCash = 1 unit of stake</li>
							<li>
								A maximum of 10 units can be staked by any Genesis Node member
							</li>
						</ul>
						<div className="grid-two-column">
							<div className="count-style-genesis">
								<span className="qty"> Units :&nbsp;&nbsp;&nbsp;</span>

								<div className="counter">
									<p
										className="minus"
										id="white-color"
										style={{ color: "#ffffff" }}
										onClick={decreaseCount}
									>
										<i className="fa fa-minus"></i>
									</p>
									<input
										type="number"
										name="update"
										id="number-update"
										value={count}
									/>
									<p
										className="plus"
										style={{ color: "#ffffff" }}
										id="white-color"
										onClick={increaseCount}
									>
										<i className="fa fa-plus"></i>
									</p>
								</div>
							</div>
							<div className="toggle-switch-genesis">
								<div className="toggle-on-off">
									<p>Stake </p>

									<label className="switch">
										<div>
											<input
												type="checkbox"
												// value={toggle}
												checked={toggle}
												onChange={() => {
													// console.log(toggle);
													setToggle((prevState) => !prevState);
												}}
												// defaultValue
											/>
											<span className="slider round"></span>
										</div>
									</label>
									<p>Unstake </p>
								</div>
							</div>
						</div>

						<div className="amount-part">
							<h2>
								Amount : &nbsp;
								<span>{(count * 100000).toLocaleString()}</span> NCash
							</h2>
							<p className="light">
								*Minimum 100k NCash tokens needs to Stake <br /> *Maximum Units
								is {maxSlots}
							</p>
						</div>
						{/* //Stake Unstake Buttons */}
						<div className="text-right stake-buttons-genesis">
							{/* {
                isWalletConnected == false && (
                  <button className="grad-border-button" onClick={connectToWallet}>Connect Wallet</button>
                )
              } */}

							{isWalletConnected == true &&
								isWalletWhitelisted == true &&
								isWalletBlacklisted == false &&
								claimableRewards > 0 && (
									<button className="grad-border-button" onClick={claimRewards}>
										Claim Reward
									</button>
								)}

							{isWalletConnected == true &&
								toggle == true &&
								isWalletWhitelisted == true &&
								isWalletBlacklisted == false && (
									<button
										className="stake-now-btn connect-wallet-btn"
										onClick={unStakeToken}
									>
										Unstake
									</button>
								)}

							{isWalletConnected == true &&
								isAlreadyApproved == false &&
								toggle == false &&
								isWalletWhitelisted == true &&
								isWalletBlacklisted == false && (
									<button
										className="stake-now-btn connect-wallet-btn"
										onClick={approveToken}
									>
										Approve
									</button>
								)}

							{isWalletConnected == true &&
								isAlreadyApproved == true &&
								toggle == false &&
								isWalletWhitelisted == true &&
								isWalletBlacklisted == false && (
									<button
										className="stake-now-btn connect-wallet-btn"
										onClick={stakeToken}
									>
										Stake Now
									</button>
								)}

							{isWalletConnected == true && isWalletWhitelisted == false && (
								<button className="stake-now-btn connect-wallet-btn">
									Not Eligible
								</button>
							)}

							{isWalletConnected == true && isWalletBlacklisted == true && (
								<button className="stake-now-btn connect-wallet-btn">
									Wallet Blacklisted
								</button>
							)}
						</div>
						{/* //Once Staked Button will changed to Unstake  */}
						{/* <div className="text-right">
              <a href="#" className="stake-now-btn connect-wallet-btn">
                Stake Now
              </a>
            </div> */}
					</div>
				</div>

				<div className="mt-3 genesis-reward">
					<div className="rewards-box-section">
						<h3>Genesis Rewards</h3>
						<div className="rewards-boxes">
							<div className="reward-box">
								<p className="mb-2">Staked Ncash</p>
								<h2>
									<span> {totalStake} </span> NCash
								</h2>
							</div>
							<div className="reward-box">
								<p className="mb-2">Claimable Rewards</p>
								<h2>
									<span> {claimableRewards} </span> NCash
								</h2>
							</div>
							<div className="reward-box">
								<p className="mb-2">Claimed Rewards</p>
								<h2>
									<span> {totalClaimedRewards} </span> NCash
								</h2>
							</div>
							<div className="reward-box">
								<p className="mb-2">Units Available to Stake</p>
								<h2>
									<span> {availableSlots} </span> Units
								</h2>
							</div>
						</div>
					</div>
				</div>

				<div className="terms-genesis">
					<h3> Important note</h3>
					<div className="terms-box">
						<ul>
							<li>
								Genesis Staking happens with all Genesis nodes (Basically,
								whitelisting wallet addresses who staked on the network from Nov
								15 2021 to April 15 2022).
							</li>
							<li>
								Rewards are calculated every 30 minutes and can be claimed
								anytime in the same interval of time.
							</li>
							<li>
								When users unstake their tokens, the unclaimed rewards will be
								auto-claimed with the unstaked amount.
							</li>
							<li>
								All interactions happen on-chain with the Avalanche network.
							</li>
							<li>
								Staking is a two-step process of Approving & Staking on-chain
								transactions with the Avalanche mainnet network.
							</li>
							<li>
								Please connect to Avalanche C-chain mainnet network and use a
								wallet which is part of the Genesis Node(whitelisting wallet).
							</li>
							<li>
								Tokens sent to this Smart contract will only be accessible to
								the wallet staking/unstaking/claiming it. Nitro Network does not
								have access to these tokens, so users are advised to protect the
								private keys to their wallets.
							</li>
						</ul>
						<br />
						<br />
						{/*<p>*/}
						{/*  To know more about Genesis Node privileges please{" "}*/}
						{/*  <a*/}
						{/*    href="https://nitronetwork.medium.com/7de86394905b"*/}
						{/*    target="_blank"*/}
						{/*  >*/}
						{/*    read our blogs*/}
						{/*  </a>{" "}*/}
						{/*  .{" "}*/}
						{/*</p>*/}
					</div>
				</div>
			</div>
		</div>
	);
}

export default GenesisNodePage;
